import {isNil} from 'ramda';

import {GenerateDescriptionRequestBody} from '@dms/api/sales';
import {DescriptionGeneratorConfigResponseBody} from '@dms/api/settings';

import {DescriptionGeneratorInputs} from '../types/DescriptionGeneratorInputs';

type GenerateBodyWithoutLanguage = Omit<GenerateDescriptionRequestBody, 'language'>;

export function buildGenerateBody(
  config: DescriptionGeneratorConfigResponseBody,
  inputs?: DescriptionGeneratorInputs
): GenerateBodyWithoutLanguage {
  if (!isNil(inputs)) {
    return {
      includeModel: inputs.includes.includes('includeModel'),
      includeEngine: inputs.includes.includes('includeEngine'),
      includeFeatures: inputs.includes.includes('includeFeatures'),
      includeCondition: inputs.includes.includes('includeCondition'),
      includeBranch: inputs.includes.includes('includeBranch'),
      quickPresetIds: inputs.quickPresets.map((qp) => qp.id),
      length: config.length,
      mentionText: config.mentionText,
      additionalInstruction: inputs.additionalInstruction,
    };
  }

  return {
    includeModel: config.includeModel,
    includeEngine: config.includeEngine,
    includeFeatures: config.includeFeatures,
    includeCondition: config.includeCondition,
    includeBranch: config.includeBranch,
    quickPresetIds: [],
    length: config.length,
    mentionText: config.mentionText,
    additionalInstruction: config.additionalInstruction,
  };
}
